import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import SydButton from '../../../../../../commonDesign/Button'
import SydLabel from '../../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../../commonDesign/SydInput'

function RenamePurposeForm ({ currentName, onSave, onClose }) {
  const [name, setName] = useState(currentName || '')

  const handleSave = useCallback(() => {
    const trimmed = name.trim()
    if (!trimmed) return
    onSave(trimmed)
  }, [name, onSave])

  return (
    <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <SydLabel label='Display Name'>
        <SydInput
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSave() }}
          placeholder='Enter display name'
        />
      </SydLabel>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
        <SydButton variant='ghost' onClick={onClose}>Cancel</SydButton>
        <SydButton variant='primary' onClick={handleSave} disabled={!name.trim()}>
          Save
        </SydButton>
      </div>
    </div>
  )
}

RenamePurposeForm.propTypes = {
  currentName: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

function RenamePurposeModal ({ open, onClose, currentName, onSave }) {
  return (
    <RoundedModal
      title='Rename Purpose'
      open={open}
      onClose={onClose}
      size='small'
      position='top'
      disablePortal={false}
    >
      {open
        ? <RenamePurposeForm currentName={currentName} onSave={onSave} onClose={onClose} />
        : <div />}
    </RoundedModal>
  )
}

RenamePurposeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentName: PropTypes.string,
  onSave: PropTypes.func.isRequired
}

export default RenamePurposeModal
